import styled from 'styled-components';
import { PageSection } from 'src/components/page';
import { layout } from '@prisjakt/ui-base';

export const StyledPageSection = styled(PageSection)`
  > * {
    margin-bottom: ${layout.measurements.spacing250};

    > *:not(:last-child) {
      margin-bottom: ${layout.measurements.spacing250};
    }
  }
`;
